import { Extension } from "@tiptap/core";

import { GUIDED_HIGHLIGHTING_ACTIVITY_PANEL } from "@/view/GuidedHighlightingContainer/utils/utils";
import { getDynamicData } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { IAnnotationDecoration } from "@/view/TiptapArticleBody/extensions/TextHighlighting";
import HighlightingPlugin from "@/view/TiptapArticleBody/extensions/TextHighlighting/HighlightingPlugin";
import {
  getCorrectGuidedHighlightingAnnotations,
  getUserSelectionAnnotations,
} from "./utils";

const GuidedHighlighting = Extension.create({
  name: "guidedHighlighting",
  addProseMirrorPlugins() {
    return [
      HighlightingPlugin({
        annotations: (state) => {
          const { activityPanel, activeGuidedHighlightingQuestion } =
            getDynamicData(state);

          if (
            activityPanel !== GUIDED_HIGHLIGHTING_ACTIVITY_PANEL ||
            !activeGuidedHighlightingQuestion
          )
            return [];

          const { attempt = 0, isCorrect } = activeGuidedHighlightingQuestion;

          let annotations: IAnnotationDecoration[] = [];

          /*
          If the student submits their response incorrectly twice,
          we highlight both the expected correct response and their last attempt,
          each styled accordingly.
          */
          if (attempt >= 2 && !isCorrect) {
            annotations = getCorrectGuidedHighlightingAnnotations(
              activeGuidedHighlightingQuestion,
            );
          } else {
            /*
            Otherwise, we simply highlight their text selection,
            styling it based on the active question.
            */
            annotations = getUserSelectionAnnotations(
              activeGuidedHighlightingQuestion,
            );
          }
          return annotations;
        },
      }),
    ];
  },
});

export default GuidedHighlighting;
